import { render, staticRenderFns } from "./MpaisGrid.vue?vue&type=template&id=a3c4573e"
import script from "./MpaisGrid.vue?vue&type=script&lang=js"
export * from "./MpaisGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports